export interface AuthInfoResponse {
  android_store_link: string;
  ios_store_link: string;
  last_used_provider: string;
  registration_link: RegistrationObj[];
  banner_url?: string;
  email_masked?: string;
  email_id?: string;
  auth_channel: string[];
  is_new_auth: boolean;
  is_login_enabled?: boolean;
}

interface RegistrationObj {
  name: string;
  url: string;
}

export interface AuthSocialResponse {
  url: string;
}

export interface MagicLinkResponse {
  status: string;
  wait_time: number;
}

export interface AuthOTPResponse {
  token: string;
  refresh_token: string;
  url: string;
}

export enum CodeType {
  PASSCODE = 'PASSCODE',
  OTPCODE = 'OTPCODE',
}
